import React, { CSSProperties } from "react";

const DorpDownSvg = ({ style, arrowStyles }: { style: CSSProperties, arrowStyles: CSSProperties }) => {
  return (
    <svg
      style={{...style, ...arrowStyles}}
      xmlns="http://www.w3.org/2000/svg"
      width="15"
      height="15"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M6 9l6 6 6-6" />
    </svg>
  );
};

export default DorpDownSvg;
